import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "relative z-10",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1)
const _hoisted_3 = { class: "flex items-end sm:items-center justify-center min-h-full p-4 text-center lg:p-0" }
const _hoisted_4 = { class: "py-4 px-5 md:px-6 border-b md:flex items-center justify-between" }
const _hoisted_5 = { class: "text-lg md:text-2xl font-medium text-gray-900" }
const _hoisted_6 = { class: "px-6 py-4" }
const _hoisted_7 = { class: "flex flex-wrap" }
const _hoisted_8 = { class: "md:w-1/2 md:pr-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg font-medium mb-3" }, "Loan amount", -1)
const _hoisted_10 = { class: "flex items-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "mr-2 text-sm" }, "from", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "mr-2 text-sm" }, "to", -1)
const _hoisted_13 = { class: "mt-5" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg font-medium mb-3" }, "Execution types", -1)
const _hoisted_15 = { class: "flex flex-wrap items-start" }
const _hoisted_16 = { class: "md:w-1/2 md:pr-4" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg font-medium mb-3" }, "Property types", -1)
const _hoisted_18 = { class: "flex flex-wrap items-start" }
const _hoisted_19 = { class: "mt-5" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-3 text-lg font-semibold" }, "Footprint", -1)
const _hoisted_21 = { class: "mt-6 flex flex-wrap" }
const _hoisted_22 = { class: "flex items-center" }
const _hoisted_23 = { class: "text-base leading-6 font-semibold" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 0,
  class: "flex flex-wrap mt-2"
}
const _hoisted_26 = { class: "text-sm" }
const _hoisted_27 = { class: "opacity-50" }
const _hoisted_28 = { class: "border-t px-6 py-4 flex justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_XIcon = _resolveComponent("XIcon")!
  const _component_list_item = _resolveComponent("list-item")!
  const _component_ChevronDownIcon = _resolveComponent("ChevronDownIcon")!
  const _component_ChevronUpIcon = _resolveComponent("ChevronUpIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: "fixed z-10 inset-0 overflow-y-auto",
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.closeModal('ModalPublicCreditBox')))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all my-8 max-w-4xl w-full",
          onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.originator.Name.split(' ')[0]) + "'s Credit Box ", 1),
            _createElementVNode("button", {
              type: "button",
              class: "border border-gray-400 bg-white rounded-md text-gray-500 hover:text-gray-800 focus:outline-none p-2 bg-gray-100 ml-4",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal('ModalPublicCreditBox')))
            }, [
              _createVNode(_component_XIcon, { class: "w-5 h-5" })
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", null, [
                  _hoisted_9,
                  _createElementVNode("p", _hoisted_10, [
                    _hoisted_11,
                    _createVNode(_component_list_item, { class: "sm:mb-0" }, {
                      default: _withCtx(() => [
                        _createTextVNode("$" + _toDisplayString(_ctx.convertToCurrency(_ctx.creditBox.AmountRange.MinimumAmount)), 1)
                      ]),
                      _: 1
                    }),
                    _hoisted_12,
                    _createVNode(_component_list_item, { class: "sm:mb-0" }, {
                      default: _withCtx(() => [
                        _createTextVNode("$" + _toDisplayString(_ctx.convertToCurrency(_ctx.creditBox.AmountRange.MaximumAmount)), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.creditBox.ExecutionTypes, (item, index) => {
                      return (_openBlock(), _createBlock(_component_list_item, { key: index }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.Description), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", null, [
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.creditBox.PropertyTypes, (item, index) => {
                      return (_openBlock(), _createBlock(_component_list_item, { key: index }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.Description), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchQuery) = $event)),
                type: "text",
                placeholder: "State name / County name / Code",
                class: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
              }, null, 512), [
                [_vModelText, _ctx.searchQuery]
              ]),
              _createElementVNode("div", _hoisted_21, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredStates, (state) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: state.stateName,
                    class: _normalizeClass(["mb-6 md:w-1/3 pr-4", { 'md:w-full flex-shrink-0': _ctx.isVisible[state.Description] }])
                  }, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("h4", _hoisted_23, _toDisplayString(state.Description), 1),
                      _createElementVNode("a", {
                        class: _normalizeClass(["text-xs text-sky font-medium ml-4 flex items-center", { 'bg-yellow-100': !_ctx.isVisible[state.Description] && _ctx.searchQuery.length }]),
                        href: "#toggle",
                        onClick: _withModifiers(($event: any) => (_ctx.toggle(state.Description)), ["prevent"])
                      }, [
                        _createTextVNode(" Counties (" + _toDisplayString(state.Types.length) + ") ", 1),
                        (!_ctx.isVisible[state.Description])
                          ? (_openBlock(), _createBlock(_component_ChevronDownIcon, {
                              key: 0,
                              class: "w-3 h-3 ml-1"
                            }))
                          : (_openBlock(), _createBlock(_component_ChevronUpIcon, {
                              key: 1,
                              class: "w-3 h-3 ml-1"
                            }))
                      ], 10, _hoisted_24)
                    ]),
                    (_ctx.isVisible[state.Description])
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.Types, (county) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "relative flex items-start mt-2 w-1/2 lg:w-1/3",
                              key: county._id
                            }, [
                              _createElementVNode("div", _hoisted_26, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["font-medium text-gray-700", { 'bg-yellow-100': _ctx.shouldHighlight(county._id, county.Description)}])
                                }, [
                                  _createTextVNode(_toDisplayString(county.Description) + " ", 1),
                                  _createElementVNode("span", _hoisted_27, "(" + _toDisplayString(county._id) + ")", 1)
                                ], 2)
                              ])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ], 2))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("button", {
              class: "inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none ring-offset-background border border-sky bg-sky text-white hover:bg-accent hover:text-accent-foreground h-10 py-2 px-4",
              onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showForm && _ctx.showForm(...args)), ["prevent"]))
            }, " Request a Quote   → ")
          ])
        ])
      ])
    ])
  ]))
}